import React from 'react';
import { Link } from 'react-router-dom';

const RiddleMePrivacyPolicy = () => {
  return (
    <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif', lineHeight: '1.6', maxWidth: '800px', margin: 'auto' }}>
      <h1 style={{ textAlign: 'center' }}>Privacy Policy for RiddleMe</h1>
      <p style={{ fontStyle: 'italic', textAlign: 'center' }}>Last Updated: January 6, 2026</p>

      <p>Welcome to RiddleMe! We value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect information when you use our app.</p>

      <p>By using RiddleMe, you agree to this Privacy Policy. If you do not agree, please do not use our app.</p>

      <h2>1. Information We Collect</h2>
      <p>RiddleMe uses Google AdMob to display advertisements. When you use our app, Google AdMob may automatically collect certain information, including:</p>
      <ul>
        <li>Device information (device type, operating system, unique device identifiers)</li>
        <li>Advertising ID (Google Advertising ID on Android, or Identifier for Advertisers on iOS)</li>
        <li>General location information (country or region level, not precise location)</li>
        <li>App usage data (how you interact with the app)</li>
      </ul>
      <p>We do not collect your name, email address, phone number, or other personal information directly. You can use RiddleMe without providing any personal information.</p>

      <h2>2. How We Use Your Information</h2>
      <p>The information collected is used to:</p>
      <ul>
        <li>Display relevant advertisements through Google AdMob</li>
        <li>Improve our app and user experience</li>
        <li>Prevent fraud and ensure security</li>
      </ul>

      <h2>3. Google AdMob</h2>
      <p>RiddleMe uses Google AdMob to serve advertisements. Google AdMob may collect and use information about your device and app usage to show you personalized ads and measure ad performance.</p>
      <p>Google's use of information collected through AdMob is governed by Google's Privacy Policy. You can learn more about how Google uses data when you use our app by visiting: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">https://policies.google.com/privacy</a></p>
      <p>For more information about Google AdMob specifically, visit: <a href="https://support.google.com/admob/answer/6128543" target="_blank" rel="noopener noreferrer">https://support.google.com/admob/answer/6128543</a></p>

      <h2>4. Your Choices and Rights</h2>
      <p>You can control personalized advertising:</p>
      <ul>
        <li><strong>Android:</strong> Go to Settings &gt; Google &gt; Ads and enable "Opt out of Ads Personalization"</li>
        <li><strong>iOS:</strong> Go to Settings &gt; Privacy &gt; Apple Advertising and enable "Limit Ad Tracking"</li>
      </ul>
      <p>Note: Opting out of personalized ads does not stop ads from appearing; you will still see ads, but they may be less relevant to your interests.</p>
      <p>If you have questions about your data or want to request deletion, please contact us through our support channels.</p>

      <h2>5. Data Sharing</h2>
      <p>We share information with Google AdMob to display advertisements. We do not sell your personal information to third parties.</p>
      <p>We may also share information if required by law or to protect our rights and safety.</p>

      <h2>6. Children's Privacy</h2>
      <p>RiddleMe is not intended for children under 13 (or 16 in the European Economic Area). We do not knowingly collect personal information from children. If you believe we have collected information from a child, please contact us immediately.</p>

      <h2>7. Security</h2>
      <p>We take reasonable measures to protect your information, but no method of transmission over the internet is 100% secure.</p>

      <h2>8. International Users</h2>
      <p>If you are using RiddleMe from outside the United States, your information may be transferred to and processed in the United States. By using our app, you consent to this transfer.</p>
      <p>If you are in the European Economic Area, you have additional rights under GDPR, including the right to access, correct, or delete your data. To exercise these rights, please contact us.</p>

      <h2>9. Third-Party Services</h2>
      <p>RiddleMe uses third-party services, including Google AdMob, which have their own privacy policies and terms of service. We are not responsible for the privacy practices of these third parties. We encourage you to review their privacy policies to understand how they handle your information.</p>

      <h2>10. Disclaimer</h2>
      <p>This Privacy Policy describes our data practices. While we strive to protect your information, we cannot guarantee absolute security. We are not responsible for the actions of third-party services (such as Google AdMob) or for any unauthorized access to your information that may occur despite our security measures.</p>
      <p>This policy does not create any contractual or legal rights beyond what is required by applicable law. We reserve the right to modify this policy at any time, and your continued use of RiddleMe constitutes acceptance of any changes.</p>

      <h2>11. Changes to This Privacy Policy</h2>
      <p>We may update this Privacy Policy from time to time. We will update the "Last Updated" date when we make changes. Your continued use of RiddleMe after changes means you accept the updated policy.</p>

      <h2>12. Contact Us</h2>
      <p>If you have any questions or concerns regarding this Privacy Policy, please contact us through the app’s available support options.</p>
      <Link to="/support">Support</Link>
      <p style={{ textAlign: 'center', fontWeight: 'bold', marginTop: '20px' }}>Thank you for using RiddleMe and trusting us with your privacy.</p>
    </div>
  );
};

export default RiddleMePrivacyPolicy;
